/* eslint-disable no-param-reassign */
import {
  SET_FILTER,
  RESET_FILTERS,
  SET_PAGINATION_ITEM,
  RESET_SET_FILTER_HAS_CHANGED,
  SET_FILTERS_HAS_RESETED,
  SET_TAB_ACTIVE_BY_PAGE,
  SET_IMAGES_BENCH_FILTER
} from 'store/actions/filters';
import { setValueObjectByField } from 'helpers/object';
import { FILTERS_BY_DEFAULT } from 'store/enums';

export default {
  [SET_FILTER]: (state, { page, filter, value }) => {
    setValueObjectByField(state[page].filters, `${filter}.value`, value);
    state[page].filtersHasChanged = true;
    state[page].filtersHasReseted = false;
  },
  [RESET_FILTERS]: (state, { page }) => {
    if (page !== 'imagesBenchFilter') {
      state[page].pagination = JSON.parse(JSON.stringify(FILTERS_BY_DEFAULT[page].pagination));
    }
    state[page].filters = JSON.parse(JSON.stringify(FILTERS_BY_DEFAULT[page].filters));
    state[page].filtersHasReseted = true;
  },
  [SET_PAGINATION_ITEM]: (state, { page, item, value }) => {
    setValueObjectByField(state[page].pagination, item, value);
  },
  [RESET_SET_FILTER_HAS_CHANGED]: (state, { page }) => {
    state[page].filtersHasChanged = false;
  },
  [SET_FILTERS_HAS_RESETED]: (state, { page }) => {
    state[page].filtersHasReseted = true;
  },
  [SET_TAB_ACTIVE_BY_PAGE]: (state, { page, value }) => {
    state[page].tabActive = value;
  },
  [SET_IMAGES_BENCH_FILTER]: (state, { page, filter, value }) => {
    setValueObjectByField(state[page].filters, `${filter}`, value);
    state[page].filtersHasChanged = true;
    state[page].filtersHasReseted = false;
  }
};
